import api from '@/api';
import {
  WorkOrderAuditDataComplementItemsRequest,
  WorkOrderAuditDataComplementItemsResponse,
  WorkOrderAuditDataComplementsRequest,
  WorkOrderAuditDataComplementsResponse,
  WorkOrderAuditDataSalesRequest,
  WorkOrderAuditDataSalesResponse,
} from './AuditData.types';
import { PageResult } from '@/core/request/PageResult';

const path = 'workorder/v1/workorders/audit-data';

const auditDataServices = {
  async complements(params?: WorkOrderAuditDataComplementsRequest) {
    const result = (await api.get(`${path}/complements`, {
      ...params,
    })) as unknown;

    return result as PageResult<WorkOrderAuditDataComplementsResponse>;
  },

  async sales(params?: WorkOrderAuditDataSalesRequest) {
    const result = (await api.get(`${path}/sales`, {
      ...params,
    })) as unknown;

    return result as PageResult<WorkOrderAuditDataSalesResponse>;
  },

  async complementItems(params?: WorkOrderAuditDataComplementItemsRequest) {
    const result = (await api.get(`${path}/complement-items`, {
      ...params,
    })) as unknown;

    return result as PageResult<WorkOrderAuditDataComplementItemsResponse>;
  },
};

export default auditDataServices;
